"use client";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";

import { TabProps } from "ui/core/horizontal-tab";

export const Select = ({
  tabs,
  activeKey,
  onChange,
}: {
  tabs: TabProps[];
  activeKey: string;
  onChange: (key: string) => void;
}) => {
  const description = tabs.find((tab) => tab.key === activeKey)?.description;
  const [value, setValue] = useState(
    tabs.find((tab) => tab.key === activeKey)?.name
  );

  useEffect(() => {
    setValue(tabs.find((tab) => tab.key === activeKey)?.name);
  }, [activeKey, tabs]);

  return (
    <div className="flex items-center gap-2.5 @3xl:hidden">
      <select
        aria-label="responsive-select"
        className="block w-full rounded-md border-gray-300 focus:border-sky-600 focus:ring-sky-600"
        onChange={(e) => {
          const key = tabs[e.target.selectedIndex].key;
          onChange(key);
        }}
        value={value}
      >
        {tabs.map((tab) => (
          <option key={tab.key} disabled={tab.isDisabled}>
            {tab.name}
          </option>
        ))}
      </select>
      {description && (
        <Tooltip
          enterTouchDelay={0}
          arrow={true}
          placement="top"
          title={description}
          slotProps={{
            tooltip: { className: "bg-zinc-900 text-white" },
            arrow: { className: "text-zinc-900" },
          }}
        >
          <QuestionMarkCircleIcon className="h-6 w-6 text-zinc-400" />
        </Tooltip>
      )}
    </div>
  );
};
